<template>
  <Teleport to="body">
    <Transition name="tg-email">
      <div v-if="authStore.showTelegramEmailWarning" class="fixed inset-0 z-[120] flex items-end justify-center" @click.self="close">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/40" @click="close" />

        <!-- Bottom sheet -->
        <div class="relative w-full max-w-[430px] bg-cream rounded-t-3xl px-6 pt-6 pb-sheet-8 z-10">
          <!-- Close button -->
          <button @click="close" class="absolute top-4 right-4 p-1">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2.5" stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          <!-- Icon -->
          <div class="flex justify-center mb-4">
            <div class="w-14 h-14 rounded-full bg-ink/10 flex items-center justify-center">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <polyline points="22,7 12,13 2,7"/>
              </svg>
            </div>
          </div>

          <h2 class="text-xl font-bold text-center text-ink mb-2">Привяжите Email к аккаунту</h2>
          <p class="text-sm text-center text-ink/70 mb-6 leading-relaxed">
            Чтобы не потерять доступ к своему аккаунту, необходимо привязать Email в настройках профиля.
          </p>

          <!-- Buttons -->
          <div class="flex gap-3">
            <button
              @click="close"
              class="flex-1 py-3 rounded-xl text-sm font-medium text-ink bg-ink/10 active:bg-ink/20 transition-colors"
            >
              Закрыть
            </button>
            <button
              @click="goToSettings"
              class="flex-1 py-3 rounded-xl text-sm font-medium text-white bg-ink active:bg-[#2a1a10] transition-colors"
            >
              Перейти в Настройки
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { watch, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../store/auth.js'

const authStore = useAuthStore()
const router = useRouter()

let savedScrollY = 0

watch(() => authStore.showTelegramEmailWarning, (val) => {
  if (val) {
    savedScrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
    window.scrollTo(0, savedScrollY)
  }
})

onUnmounted(() => {
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
})

function close() {
  authStore.showTelegramEmailWarning = false
  sessionStorage.setItem('tg-email-warning-dismissed', '1')
}

function goToSettings() {
  authStore.showTelegramEmailWarning = false
  sessionStorage.setItem('tg-email-warning-dismissed', '1')
  router.push('/profile/account')
}
</script>

<style scoped>
.tg-email-enter-active,
.tg-email-leave-active {
  transition: opacity 0.3s ease;
}
.tg-email-enter-active .relative,
.tg-email-leave-active .relative {
  transition: transform 0.3s ease;
}
.tg-email-enter-from,
.tg-email-leave-to {
  opacity: 0;
}
.tg-email-enter-from .relative {
  transform: translateY(100%);
}
.tg-email-leave-to .relative {
  transform: translateY(100%);
}
</style>
